import React, { useState, useEffect } from "react";
import styles from "./SmartAppBanner.module.scss";
import { ReactComponent as XIcon } from "assets/img/close.svg";
import { useAtom } from "jotai";
import { showBannerAtom } from "showMessageMenuAtom";

const SmartAppBanner = () => {
  const [appLink, setAppLink] = useState<any>(null);
  const [showBanner, setShowBanner] = useAtom(showBannerAtom);

  const userAgent = navigator.userAgent;

  // Call this when user dismisses the banner
  function dismissSmartBanner(): void {
    localStorage.setItem("appBannerDismissedTimestamp", Date.now().toString());
  }

  useEffect(() => {
    // const isIOS = /iPhone|iPad|iPod/.test(userAgent) && !/Macintosh/.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/.test(userAgent) ||
      (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(userAgent);
    const isMobileDevice = isIOS || isAndroid;

    // If not on mobile device, don't show banner
    if (!isMobileDevice) {
      setShowBanner(false);
      return;
    }

    // Check if banner was previously dismissed
    const wasBannerDismissed = localStorage.getItem("appBannerDismissed") === "true";

    // If banner wasn't dismissed or we're checking the initial state
    if (!wasBannerDismissed) {
      setShowBanner(true);

    // Set appropriate app store link based on device
      if (isIOS) {
        setAppLink("https://apps.apple.com/us/app/groupapp-communities/id1634022484");
      } else {
        setAppLink("https://play.google.com/store/apps/details?id=app.group.groupapp&pli=1%20");
      }
    } else {
      setShowBanner(false);
    }
  }, []);

  const handleDismiss = () => {
    dismissSmartBanner();
    setShowBanner(false);
    localStorage.setItem("appBannerDismissed", "false");
  };

  if (!showBanner || window.location.pathname === '/signup') return null;

  return (
    <div className={styles.banner} id='SmartAppBanner'>
      <div>
        <button onClick={handleDismiss} className={styles.dismissButton}>
          <XIcon />
        </button>
        <a href={appLink}>
          <div className={styles.banner__top}>
            <img src="https://static.group.app/assets/icons/ic_launcher.png" alt="GroupApp communities" />
            <div>
              <h1>GroupApp Communities  </h1>
              <p>Your communities on the go</p>
            </div>
          </div>
          <span className={styles.banner__top__appLink}>
            Download App
          </span>
        </a>

      </div>
    </div>
  );
};

export default SmartAppBanner;
